export default "__VITE_ASSET__B3kS_fe6__"